"use client";
import Image from "next/image";

import { imageLoader } from "@aprosoja/utils";
import { Breadcrumb, Text } from "@aprosoja/ui";

import useBoardMembers from "./use-board-members";

const BoardMembers = () => {
  const { boardMembers } = useBoardMembers();

  const segments = [{ label: "Diretoria", path: "diretoria" }];

  return (
    <div className="flex flex-col gap-size-x10 py-size-x14 px-size-x4 max-w-[1560px] tabletMedium:px-size-x10 mx-auto">
      <Breadcrumb segments={segments} />
      <Text type="headingXL">Diretoria 2021/2024</Text>
      <div className="flex px-size-x8 gap-size-x6 flex-wrap tabletSmall:px-size-x15 tabletLarge:px-size-x30">
        {boardMembers?.map((boardMember) => (
          <div
            key={boardMember.id}
            className="flex flex-col w-size-x50 gap-size-x4"
          >
            <Text type="headingXS">{boardMember.positionName}</Text>
            <div className="relative w-size-x50 h-size-x50 content-center items-center">
              <Image
                loader={imageLoader}
                src={boardMember.imageUrl}
                alt="foto-perfil"
                fill
                style={{ objectFit: "contain" }}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            </div>
            <Text type="paragraphM">{boardMember.name}</Text>
            {!!boardMember.state.id && (
              <Text type="paragraphS" color="th-color-neutral-400">
                {boardMember.state.initials}
              </Text>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoardMembers;
